import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Icon from '../AppIcon';
import Input from '../ui/Input';
import Button from '../ui/Button';
import { supabase } from "../../lib/supabase"; // Koristimo direktno supabase za reset

const ForgotPasswordModal = ({ isOpen, onClose, onBackToLogin }) => {
  const { t, i18n } = useTranslation(); // POPRAVLJENO
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });

  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : 'unset';
    return () => { document.body.style.overflow = 'unset'; };
  }, [isOpen]);

const handleSubmit = async (e) => {
    e?.preventDefault();
    if (!email) return;

    setIsLoading(true);
    setMessage({ type: '', text: '' });

    try {
      const { error } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: `${window.location.origin}/reset-password`,
        // DODAJEMO DATA OBJEKAT:
        data: {
          lang: i18n.language // Šalje 'bs', 'it', 'de' ili 'en'
        }
      });

      if (error) throw error;

      setMessage({ type: 'success', text: t('auth.success_msg') });
      setTimeout(() => {
        handleClose();
      }, 3000);
    } catch (err) {
      setMessage({ type: 'error', text: err.message });
    } finally {
      setIsLoading(false);
    }
  };

  const handleClose = () => {
    setEmail('');
    setMessage({ type: '', text: '' });
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div 
      className="modal-overlay fixed inset-0 z-[110] flex items-center justify-center bg-black/50 backdrop-blur-[2px] transition-opacity animate-in fade-in duration-200 px-4" 
      onClick={handleClose}
    >
      <div 
        className="modal-content w-full max-w-md bg-card rounded-3xl shadow-2xl overflow-hidden animate-in zoom-in-95 duration-200" 
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header p-6 flex justify-between items-center border-b border-border">
          <h2 className="modal-title font-black uppercase text-sm tracking-widest">{t('auth.reset_title')}</h2>
          <button onClick={handleClose} className="p-2 hover:bg-muted rounded-xl transition-colors text-muted-foreground">
            <Icon name="X" size={20} />
          </button>
        </div>
        
        <div className="p-6 pb-10">
          <p className="text-muted-foreground text-[11px] font-bold uppercase tracking-wider mb-6 px-1">
            {t('auth.reset_desc')}
          </p>

          {message.text && (
            <div className={`mb-6 p-4 border rounded-2xl ${
              message.type === 'success' ? 'bg-emerald-50 border-emerald-100 text-emerald-600' : 'bg-red-50 border-red-100 text-red-500'
            }`}>
              <p className="text-xs text-center font-bold tracking-wide uppercase">{message.text}</p>
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-6">
            <Input 
              type="email" 
              name="email" 
              label={t('auth.email')} 
              value={email} 
              onChange={(e) => setEmail(e.target.value)} 
              required 
              placeholder="example@mail.com"
            />

            <div className="pt-4 flex flex-col gap-4">
              <Button type="submit" fullWidth loading={isLoading} className="shadow-lg shadow-primary/20">
                {t('auth.send_link')}
              </Button>

              <button 
                type="button"
                className="text-center text-[11px] font-black uppercase tracking-widest text-muted-foreground hover:text-primary transition-colors py-2 flex items-center justify-center gap-2"
                onClick={onBackToLogin}
              >
                <Icon name="ArrowLeft" size={14} />
                {t('auth.back_to_login')}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordModal;